import { flattenItems, getEmptyModel } from "../../MDDForm/helper.js";
import { buildFormSchema } from "./buildFormSchema.js";

/**
 * Coverage types of the Sparten listed by id in formdata `_coverage_types`.
 * `objektSparten` is `[{ sparte_id, coverage_type }]` of the claim's Objekt.
 */
export function selectedCoverageKeys(coverageTypeIds, objektSparten) {
  const keys = (coverageTypeIds ?? [])
    .map(
      (id) =>
        objektSparten?.find((sparte) => sparte.sparte_id === id)?.coverage_type
    )
    .filter(Boolean);
  return [...new Set(keys)];
}

/**
 * Evaluates the definition's `valid` rules against stored formdata without
 * rendering: `shared` covers every field outside a Sparte step, `coverage`
 * has one entry per selected coverage type for the fields of its step.
 * Without a selected coverage type the claim has no situation, so `shared`
 * is false.
 */
export function validateCoverageSteps(definition, formdata, selectedKeys) {
  const shared = [];
  const by_key = {};

  (definition.formdefinition ?? []).forEach((item) => {
    if (item.control !== "stepper") {
      shared.push(...flattenItems([item]));
      return;
    }
    item.steps.forEach((step) => {
      const fields = flattenItems(step.children);
      if (step.coverage_type) {
        by_key[step.coverage_type] = [
          ...(by_key[step.coverage_type] ?? []),
          ...fields,
        ];
      } else {
        shared.push(...fields);
      }
    });
  });

  // The backend stores a field that was never filled in as null, which the
  // form schema accepts even for a required field. The form itself starts such
  // a field from its empty value, so validate the same way.
  const filled = Object.fromEntries(
    Object.entries(formdata ?? {}).filter(([, value]) => value !== null)
  );
  const data = {
    ...getEmptyModel(definition.formdefinition ?? []),
    ...filled,
  };

  const isValid = (fields) => buildFormSchema(fields).isValidSync(data);

  return {
    shared: selectedKeys.length > 0 && isValid(shared),
    coverage: Object.fromEntries(
      selectedKeys.map((key) => [key, isValid(by_key[key] ?? [])])
    ),
  };
}
